module.exports = __webpack_public_path__ + "assets/471728fde5ea51f8e4df6060168ff118.png";